import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import cn from 'classnames';

import { DrawerContext, Text } from '@notino/react-styleguide';

import { ICharacteristic } from '@containers/ProductListing/model';
import { isDesktop } from '@utils/helpers';

import { CharacteristicsTable } from '../styled';

import { AllParametersContent } from './AllParametersContent';
import { Characteristic } from './Characteristic';
import {
  CharacteristicsTableWrapper,
  drawerHeaderClassName,
  fadeCropClassName,
  ShowParametersButton,
} from './styled';

type Props = {
  characteristics: ICharacteristic[];
};

const MIN_CHARACTERISTICS_FOR_DRAWER = 6;

export const Characteristics = ({ characteristics }: Props) => {
  const parametersDrawerAvailable =
    characteristics.length > MIN_CHARACTERISTICS_FOR_DRAWER &&
    characteristics.every((item) => Boolean(item.group));

  const { openDrawer } = DrawerContext.useDrawerContext();

  const handleShowAllParameters = () => {
    openDrawer(<AllParametersContent characteristics={characteristics} />, {
      initialPosition: 'top',
      hideScrollbar: true,
      headerCustomStyles: drawerHeaderClassName,
      title: (
        <>
          {!isDesktop() && <div style={{ width: 52 }} />}
          <Text typography="labelLarge" marginX="20px">
            <FormattedMessage
              id="pd.characteristics.parametersDrawer.title"
              defaultMessage="Parametry"
            />
          </Text>
        </>
      ),
    });
  };

  return (
    <CharacteristicsTableWrapper>
      <div className={cn({ [fadeCropClassName]: parametersDrawerAvailable })}>
        <CharacteristicsTable>
          <tbody>
            {characteristics.map((item) => (
              <Characteristic key={item.name} item={item} fullWidth={true} />
            ))}
          </tbody>
        </CharacteristicsTable>
      </div>

      {parametersDrawerAvailable && (
        <ShowParametersButton onClick={handleShowAllParameters}>
          <FormattedMessage
            id="pd.characteristics.showAllParameters"
            defaultMessage="Zobrazit všechny parametry"
          />
        </ShowParametersButton>
      )}
    </CharacteristicsTableWrapper>
  );
};
